import { reactive, toRefs } from "@vue/composition-api";
import { sleep } from "@/helpers/sleep";

let data = null;

export function useNotification() {
  data =
    data ||
    reactive({
      notificationShow: false,
      notificationMsg: "",
      notificationType: "",
    });

  async function showNotification(type, msg, persistent) {
    data.notificationShow = true;
    data.notificationMsg = msg;
    data.notificationType = type;
    if (!persistent) {
      await sleep(4000);
      data.notificationShow = false;
    }
  }

  function hideNotification() {
    data.notificationShow = false;
  }

  return {
    ...toRefs(data),
    showNotification,
    hideNotification,
  };
}
